import {VanillaReaderPublication} from "./VanillaReaderPublication";
import {VanillaReaderUtils} from "./VanillaReaderUtils";
import {MediaTypeDetector} from "@colibrio/colibrio-reader-framework/colibrio-core-io-mediatypedetector";
import {MediaType} from "@colibrio/colibrio-reader-framework/colibrio-core-io-base";
import {VanillaReaderEventBus} from "../VanillaReaderEventBus/VanillaReaderEventBus";

export class VanillaReaderAudiobookReaderView {
    constructor(
        private _vanillaReaderPublication: VanillaReaderPublication,
        private _appElement: HTMLElement,
    ) {}

    async render(): Promise<void> {
        const colibrioReaderPublication = this._vanillaReaderPublication.getColibrioReaderPublication();

        if (VanillaReaderUtils.isWpAudiobookReaderPublication(colibrioReaderPublication)) {
            const sourcePublication = colibrioReaderPublication.getSourcePublication();
            const coverImageResourceUrl = sourcePublication.getCoverImageResourceUrl();

            if (coverImageResourceUrl) {
                const coverImageResponse = await sourcePublication.getBackingResourceProvider().fetch(coverImageResourceUrl);
                const coverImageData = await coverImageResponse.asUint8Array();
                const mediaType = MediaTypeDetector.detectFromUint8Array(coverImageData);
                const objectURL = URL.createObjectURL(new Blob([coverImageData], {type: mediaType || MediaType.IMAGE_JPEG}));

                // As the audiobook does not really have a "ReaderView" equivalent, we just insert some markup to show the
                // book cover.
                this._appElement.insertAdjacentHTML('afterbegin', `
                <div id="vanilla-reader__reader-view__audiobook-cover-container">
                    <img src="${objectURL}" aria-label="Book cover" id="vanilla-reader__reader-view__audiobook-cover-container__image" alt="Book cover">
                </div>`);

                this._appElement.addEventListener('pointerdown', (ev: PointerEvent) => {
                    VanillaReaderEventBus.dispatchEvent(VanillaReaderEventBus.createEvent('POINTER_DOWN', {
                        srcEventData: ev,
                    }));
                });
                this._appElement.addEventListener('pointerup', (ev: PointerEvent) => {
                    VanillaReaderEventBus.dispatchEvent(VanillaReaderEventBus.createEvent('POINTER_UP', {
                        srcEventData: ev,
                    }));
                });
            }
        } else {
            throw new Error('VanillaReaderAudiobookReaderView.render(), The publication is not a WpAudiobookReaderPublication.');
        }

    }

}
